import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Card, Modal, Table } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AccountBean, ItemResponseAccountBeanObject, ListPagination } from 'src/api/api'
import { StorageKey, storageReaderFactory, storageWriterFactory } from 'src/util/Storage'
import { toSort, useSorter } from 'src/util/useSorter'
import accountApi from './AccountApi'

const Column = Table.Column

const storageWriter = storageWriterFactory('account')
const storageReader = storageReaderFactory('account')

interface Props { }

const AccountList: React.FC<Props> = () => {

    const [data, setData] = useState<AccountBean[]>([])
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1
    })

    const remove = (record: AccountBean) => {
        Modal.confirm({
            title: `Delete ${record.name}?`,
            content: 'Are you sure?',
            cancelText: 'NO',
            okText: 'Yes, I\'m sure',
            onOk: async () => {
                await accountApi.delete(record.id as number)
                let page = pagination.current
                if (data.length == 1 && pagination.current > 1) {
                    page -= 1
                }
                loadData(page)
            }
        })
    }

    const loadData = async (page: number) => {
        const response = await accountApi.list(pagination.defaultPageSize, page, toSort(sorter))

        const array = response.data as Array<ItemResponseAccountBeanObject>
        const accountBeans: AccountBean[] = array.map(item => item.data as AccountBean)

        if (accountBeans.length == 0 && page > 1) {
            loadData(page - 1)
        } else {
            const newPagination: ListPagination = response.pagination as ListPagination
            storageWriter.write(StorageKey.SearchParams, {
                page: newPagination.currentPage
            })

            setData(accountBeans)
            setPagination({ ...pagination, total: newPagination.total, current: newPagination.currentPage })
        }
    }

    const { sorter, handleTableChange } = useSorter(pagination, loadData)

    useEffect(() => {
        const searchParams = storageReader.read(StorageKey.SearchParams)
        const page = searchParams.page || pagination.current

        loadData(page)
    }, [sorter])

    return <Card size="small" className="form-card">
        <div className="list-filter-group">
            <Link to={`/account/create`} className="create-new-link">
                <Button type="primary" htmlType="button">
                    Create new
                </Button>
            </Link>
        </div>
        <Table
            rowKey="id"
            size="middle"
            dataSource={data}
            pagination={{ ...pagination, size: 'default' }}
            onChange={handleTableChange}
        >
            <Column key="id" title="ID" dataIndex="id" sorter />
            <Column key="name" title="Name" dataIndex="name" sorter render={(text, record: AccountBean) => <Link to={`/account/${record.id}/edit`}>{text}</Link>} />
            <Column key="email" title="Email" dataIndex="email" />
            <Column key="role" title="Role" dataIndex="role" />
            <Column align="center" key="action" title="Actions" render={(text: string, record: AccountBean) => (
                <span>
                    <Link to={`/account/${record.id}/edit`}>
                        <Button type="text" >
                            <EditOutlined />
                        </Button>
                    </Link>
                    <Button type="text" danger onClick={() => remove(record)}>
                        <DeleteOutlined />
                    </Button>
                </span>
            )} />
        </Table>
    </Card>
}

export default AccountList


// WEBPACK FOOTER //
// ./src/component/app/account/AccountList.tsx